import { toast } from 'sonner';

export const GENERAL_FEATURE_UNAVAILABLE_TOAST =
  'This feature is currently unavailable. Try again later. Check status.lurna.co for more information.';

export type GeneralFeature =
  | 'blankNote'
  | 'pdfNote'
  | 'course'
  | 'courseSubfolder'
  | 'studySetCreation'
  | 'studySetFolder';

export const GENERAL_FEATURES_LIST: readonly GeneralFeature[] = [
  'blankNote',
  'pdfNote',
  'course',
  'courseSubfolder',
  'studySetCreation',
  'studySetFolder',
] as const;

export const DEFAULT_GENERAL_FEATURES_ALL_ENABLED: Record<
  GeneralFeature,
  boolean
> = {
  blankNote: true,
  pdfNote: true,
  course: true,
  courseSubfolder: true,
  studySetCreation: true,
  studySetFolder: true,
};

export const GENERAL_FEATURE_ENV_KEYS: Record<
  GeneralFeature,
  keyof ImportMetaEnv
> = {
  blankNote: 'VITE_GENERAL_FEATURE_BLANK_NOTE',
  pdfNote: 'VITE_GENERAL_FEATURE_PDF_NOTE',
  course: 'VITE_GENERAL_FEATURE_COURSE',
  courseSubfolder: 'VITE_GENERAL_FEATURE_COURSE_SUBFOLDER',
  studySetCreation: 'VITE_GENERAL_FEATURE_STUDY_SET_CREATION',
  studySetFolder: 'VITE_GENERAL_FEATURE_STUDY_SET_FOLDER',
};

function parseEnvBoolString(
  raw: string | undefined,
  defaultWhenMissing: boolean
): boolean {
  if (raw === undefined || raw === '') return defaultWhenMissing;
  const s = raw.toLowerCase().trim();
  if (s === '') return defaultWhenMissing;
  return s !== 'false' && s !== '0' && s !== 'no' && s !== 'off';
}

export function readGeneralFeatureFlagsFromImportMeta(
  env: ImportMetaEnv
): Record<GeneralFeature, boolean> {
  const flags: Record<GeneralFeature, boolean> = {
    ...DEFAULT_GENERAL_FEATURES_ALL_ENABLED,
  };
  for (const key of GENERAL_FEATURES_LIST) {
    const raw = env[GENERAL_FEATURE_ENV_KEYS[key]] as string | undefined;
    if (raw !== undefined && raw !== '') {
      flags[key] = parseEnvBoolString(raw, true);
    }
  }
  return flags;
}

export function notifyGeneralFeatureUnavailable(): void {
  toast.error(GENERAL_FEATURE_UNAVAILABLE_TOAST);
}
